import { FC, useMemo } from 'react'
import { Route, Routes, useLocation } from 'react-router'
import ModuleGuard, { ModuleIndexRedirect } from 'components/shared/ModuleGuard'
import PreConListing from './PreConListing'
import ProListing from './ProListing'
import ProListingProvider from '../provider/ProListingProvider'
import BrokerageListing from './BrokerageListing'

export const PropertyRoutes: FC = () => {
 const { pathname } = useLocation()

 const lType = useMemo(() => {
  if (pathname?.split('/')?.at(-1) === 'pre-con-listing') {
   return 'preconstruction'
  }
  if (pathname?.split('/')?.at(-1) === 'brokerage-listing') {
   return 'brokerage'
  }
  return 'listing'
 }, [pathname])

 return (
  <ProListingProvider
   from={
    pathname?.split('/')?.at(-1) === 'pre-con-listing'
     ? 'preconstruction'
     : 'listing'
   }
   lType={lType}
  >
   <Routes>
    <Route
     path=""
     element={
      <ModuleIndexRedirect
       options={[
        { path: 'property-listing', module: 'listing_mls' },
        { path: 'pre-con-listing', module: 'listing_precon' },
       ]}
      />
     }
    />
    <Route
     path="property-listing"
     element={
      <ModuleGuard module="listing_mls">
       <ProListing />
      </ModuleGuard>
     }
    />
    <Route
     path="pre-con-listing"
     element={
      <ModuleGuard module="listing_precon">
       <PreConListing />
      </ModuleGuard>
     }
    />
    <Route
     path="brokerage-listing"
     element={
      <ModuleGuard module="listing_brokerage_listings">
       <BrokerageListing />
      </ModuleGuard>
     }
    />
   </Routes>
  </ProListingProvider>
 )
}
